import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcess1071041Status: 'idle',
    startProcess1071041Error: undefined as any,
    loadUserParamsProcess1071041Status: 'idle',
    loadUserParamsProcess1071041Error: undefined as any,

    process1071041List: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startProcess1071041 = createAsyncThunk('process1071041Slice/startProcess1071041', async ({ process1071041 }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcess1071041/`,
        prepareData(process1071041),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startProcess1071041Status } = getState().process1071041Slice
        return startProcess1071041Status !== 'pending'
    }
})

export const loadUserParamsProcess1071041 = createAsyncThunk('process1071041Slice/loadUserParamsProcess1071041', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcess1071041/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsProcess1071041Status } = getState().process1071041Slice
        return loadUserParamsProcess1071041Status !== 'pending'
    }
})

const Process1071041Slice = createSlice({
    name: 'process1071041Slice',
    initialState,
    reducers: {
        resetstartProcess1071041: (state) => {
            state.job = undefined
            state.startProcess1071041Error = undefined
        },
        resetstartProcess1071041Error: (state) => {
            state.startProcess1071041Error = undefined
        },
        resetloadUserParamsProcess1071041: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcess1071041Error = undefined
        },
        resetloadUserParamsProcess1071041Error: (state) => {
            state.loadUserParamsProcess1071041Error = undefined
        },
        removeFromProcess1071041ListById: (state, action) => {
            state.process1071041List = state.process1071041List.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcess1071041ListByIds: (state, action) => {
            state.process1071041List = state.process1071041List.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.process1071041List = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcess1071041Status = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.process1071041List = []
            state.startProcess1071041Status = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcess1071041.pending, (state) => {
            state.startProcess1071041Status = 'pending'
            state.startProcess1071041Error = undefined
        })
        builder.addCase(startProcess1071041.fulfilled, (state, action) => {
            state.startProcess1071041Status = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startProcess1071041.rejected, (state, action) => {
            state.startProcess1071041Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcess1071041Error = action.error.message
            } else {
                state.startProcess1071041Error = action.payload
            }
        })

        builder.addCase(loadUserParamsProcess1071041.pending, (state) => {
            state.loadUserParamsProcess1071041Status = 'pending'
            state.loadUserParamsProcess1071041Error = undefined
        })
        builder.addCase(loadUserParamsProcess1071041.fulfilled, (state, action) => {
            state.loadUserParamsProcess1071041Status = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsProcess1071041.rejected, (state, action) => {
            state.loadUserParamsProcess1071041Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcess1071041Error = action.error.message
            } else {
                state.loadUserParamsProcess1071041Error = action.payload
            }
        })

    }
})

export const {
    resetstartProcess1071041,
    resetstartProcess1071041Error,
    resetloadUserParamsProcess1071041,
    resetloadUserParamsProcess1071041Error,
    removeFromProcess1071041ListById,
    removeFromProcess1071041ListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = Process1071041Slice.actions
export default Process1071041Slice.reducer
